import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Link } from "react-router-dom";
import * as actions from '../../store/actions/index';
import { currentLang } from '../../store/actions/support';
import { format } from 'date-fns'
import ReadSingleDownloadButton from '../Documentations/ReadSingleDownloadButton.js'
import ReadAllDownloadButton from '../Documentations/ReadAllDownloadButton.js'
import { useTranslation } from 'react-i18next';

const HomeDownloads = (props) => {

  const linkTo = props.linkTo
  const linkText = "Alle Gelesen"
  const { t } = useTranslation();

  let documentationFileUserInfos = [];
  const loading = useSelector(state => state.inventory.loadingDocumentationFileUserInfos );
  const dispatch = useDispatch();


  const downloadFile = (filename, id) => {
    dispatch(actions.downloadDocumentationPdf(filename, id));
  };

  useEffect(() => {
    dispatch( actions.fetchAllDocumentationFileUserInfos() );
  }, []);

  const thisDocumentationFileUserInfos = useSelector(state => {
    return (productSystemId) => actions.getAllDocumentationFileUserInfos(state)
  });

  if ( !loading ) {
    documentationFileUserInfos = thisDocumentationFileUserInfos() || [];
  }


  if ( documentationFileUserInfos.length > 0 ) {

    return (
      <div className="tab-content-white">
         <div className="tab-pane fade show active" id="tasks" role="tabpanel" data-filter-list="card-list-body">
            <div className="row content-list-head">
               <div className="col-auto">
                  <h2 className="projectlist">{ t('dashboard.box_downloads.headline')}</h2>
               </div>
            </div>
            <div className="content-list-body dashboard">

              <table className="table table-striped downloads">
                <thead>
                  <tr>
                    <th scope="col">{ t('dashboard.box_downloads.table_col.product_system')}</th>
                    <th scope="col">{ t('dashboard.box_downloads.table_col.document')}</th>
                    <th scope="col">{ t('dashboard.box_downloads.table_col.date')}</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  { documentationFileUserInfos.map( doc =>
                    <tr className='updated_file' key={doc.id}>
                      <td>{doc.product_system_name}</td>
                      <td onClick={() => downloadFile(doc.documentation_file.filename, doc.documentation_file.id)} className="filename">{ doc.documentation_file.text[currentLang()] }</td>
                      <td>{ format(new Date(doc.documentation_file.update_at), 'dd.MM.yyyy')  }</td>
                      <td style={{textAlign: "right", paddingRight: "20px"}}><ReadSingleDownloadButton documentationFileUserInfoId={doc.id}/></td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>
            <div className="dashboard-btn-right">
              <ReadAllDownloadButton />
            </div>
         </div>
      </div>
    )
  } else {
   return null;
  }

};

export default HomeDownloads;



// WEBPACK FOOTER //
// ./src/components/Home/HomeDownloads.js